var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h2',[_vm._v("\n    "+_vm._s(_vm.message ||
        _vm.translatedMessage ||
        this.$t('_web_404_error', 'Wrong URI or endpoint not implemented yet'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }